export default {
    appVersionNumber: '1.62.1',
    // basePath: 'https://ssb-test.tekmoni.com/ssb-jaxrs-server/exis/ssb/v2.0',
    // bffBasePath: "https://bff-test.bikermobile.com",
    // shopOriginUrl: "https://shop-test.bikermobile.com",
    basePath: 'https://ssb.tekmoni.com/ssb-jaxrs-server/exis/ssb/v2.0',
    bffBasePath: "https://bff.bikermobile.com",
    shopOriginUrl: "https://shop.bikermobile.com",
    // stripePublicKey: "pk_test_51ROLBx2NAXSS9OwdCmMTfaZq7mfX6jPLN5rlYGx5BsJjieYVKwdtybAXkgNA8vc5fW5bkRZRpy7WpVgEOymXyeMA00xb1I9jXm",
    stripePublicKey: "pk_live_51ROLBiRrBOSYxanJJZG7Gdv1YWKxWK6jQqSAIpUDHqNKXeJ2a68LSOPzB5Q6MykxCoaGFkB8PL86vyp2XVmciOEU00FLCqSqyV", //PROD
    apiVersion: 'V3.0.30',
    catalogName: 'ESIMGO',
    operatorCode: 'ESIMGO',
    numberRegex: '^(07[0-9]{9})$',
    encryptionKey: 'M&Pdnm8!_exis',
    activationProduct: 'ESIMGO-ACTIVATE-SUBSCRIPTION',
    applyDiscountProduct: 'APPLY-DISCOUNT',
    portInProduct: 'ESIMGO-PORT-IN',
    portOutProduct: 'ESIMGO-PORT-OUT',
    changePlanProduct: 'ESIMGO-CHANGE-PLAN',
    cancelChangePlanProduct: 'ESIMGO-CANCEL-CHANGE-PLAN',
    autoRenewProduct: 'ESIMGO-AUTO-RENEW-SUBSCRIPTION',
    linkPsimProduct: 'LINK-PSIM-CUSTOMER',
    updatePaymentMethodProduct: 'UPDATE-PAYMENT-DETAILS',
    channelName: 'BIKERMOBILE-APP',
    paymentGateway: 'stripe',
    defaultLanguage: 'en',
    pollingMaxRetries: 120,
    callCenterNumber: '+441912755000',
    whatsAppNumber: '447412694559',
    agentUsername: 'ESIMGO-SHOPPING-AGENT',
    agentPassword: 'Passw001',
    guestUsername: 'ESIMGO-GUEST-ROOT',
    guestPassword: 'Passw001',
    customerNotificationHostedGateway: 'wufoo',
    iccidPrefix: '894410003050020',
}